(() => {
  const STORAGE_KEY = 'gbrand-page-transition-arrival';
  const NAVIGATE_AFTER_MS = 690;
  const REVEAL_CLEANUP_MS = 700;
  let overlay = null;
  let navigating = false;

  const prefersReducedMotion = () =>
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

  function mountOverlay() {
    if (overlay?.isConnected) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'gbrand-page-transition';
    overlay.setAttribute('aria-hidden', 'true');

    for (let i = 0; i < 6; i += 1) {
      const band = document.createElement('span');
      band.className = 'gbrand-page-transition__band';
      overlay.appendChild(band);
    }

    document.body.appendChild(overlay);
    return overlay;
  }

  function revealOnArrival() {
    if (prefersReducedMotion()) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    if (sessionStorage.getItem(STORAGE_KEY) !== '1') return;
    sessionStorage.removeItem(STORAGE_KEY);

    const el = mountOverlay();
    el.classList.remove('is-covering');
    el.classList.add('is-revealing');

    window.setTimeout(() => {
      el.classList.remove('is-revealing');
    }, REVEAL_CLEANUP_MS);
  }

  function getNavigableUrl(anchor) {
    if (!anchor) return null;
    if (anchor.hasAttribute('download')) return null;
    if (anchor.target && anchor.target !== '_self') return null;
    if (anchor.closest('[data-no-page-transition]')) return null;

    const rawHref = anchor.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#')) return null;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(rawHref)) return null;

    let url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch {
      return null;
    }

    if (!/^https?:$/.test(url.protocol)) return null;
    if (url.origin !== window.location.origin) return null;

    const blockedPaths = ['/cart', '/checkout', '/checkouts', '/challenge', '/password'];
    if (blockedPaths.some((path) => url.pathname === path || url.pathname.startsWith(`${path}/`))) {
      return null;
    }

    if (url.href === window.location.href) return null;

    const sameDocumentHash =
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      Boolean(url.hash);

    if (sameDocumentHash) return null;

    return url;
  }

  function beginTransition(url) {
    if (navigating) return;

    if (prefersReducedMotion()) {
      window.location.assign(url.href);
      return;
    }

    navigating = true;
    const el = mountOverlay();

    el.classList.remove('is-revealing');
    el.classList.remove('is-covering');
    void el.offsetWidth;
    el.classList.add('is-covering');

    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // Navigation still works even if storage is unavailable.
    }

    window.setTimeout(() => {
      window.location.assign(url.href);
    }, NAVIGATE_AFTER_MS);
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target = event.target instanceof Element ? event.target : null;
    const anchor = target?.closest('a[href]');
    const url = getNavigableUrl(anchor);
    if (!url) return;

    event.preventDefault();
    beginTransition(url);
  });

  window.addEventListener('pageshow', (event) => {
    navigating = false;

    if (event.persisted && overlay) {
      overlay.classList.remove('is-covering', 'is-revealing');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealOnArrival, { once: true });
  } else {
    revealOnArrival();
  }
})();
